import React from 'react'
import '../../../../App.scss';
import Grid from "@material-ui/core/Grid";
import LightImage from '../../../../assets/images/img_progress_light.png'
import After from "../../../../assets/mp3/after_sound.mp3";
import Before from "../../../../assets/mp3/before_sound.mp3";
import Loose from "../../../../assets/mp3/lose.mp3";
class CountdownProgress extends React.Component{
    constructor(props) {
        super(props)
        this.state={
            loaderPercentage:0,
            interval:null,
            isPending: false,
            fetchedData:null,
            color:'green',
            audio:null,
        }
        this.audio=new Audio(Before)
        this.interval=null
    }
    componentDidMount() {
        this.progressInterval()
    }
    async componentWillUnmount() {
        try {
            this.audio=null
        }
        catch (e){
            console.log(e)
        }
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        const play = this.props.data
        if (!play){
            clearInterval(this.interval)
            if (this.audio !== null)
                this.audioPause()
        }
    }

    progressInterval=() =>{
        const interval =  setInterval(this.progress, 1000);
        this.interval=interval
    }
    audioPause=async () =>{
        try {
            if ( this.interval!==null && this.audio !==null ){
                await this.audio.pause()
                this.audio.currentTime=this.audio===null??0
            }
        }catch (e) {
        }
    }
    progress=async ()=>{
        if (this.audio === null)
            return
        await this.audio.play()
        setTimeout(async ()=>{
            await this.audioPause()
        },900)
        this.setState((state) => ({
            loaderPercentage: (state.loaderPercentage +10)
        }));
        if (this.state.loaderPercentage===40){
            this.audio=new Audio(After)
        }
        if (this.state.loaderPercentage>=50){
            this.setState((state) => ({
                color: 'red',
            }));
        }
        if (this.state.loaderPercentage>=this.props.timeOut*10){
            this.setState((state) => ({
                color: 'red',
            }));
        }
        if (this.state.loaderPercentage===this.props.timeOut*10){
            setTimeout(async ()=>{
                clearInterval(this.interval)
                this.props.done(true)
            },500)
        }
    }
    render() {
        return (
            <Grid className="progress" style={{position:'relative',height:'100%'}} container justify={"center"}>
                <Grid item className="progressbar" justify={"center"}  container alignItems={"flex-end"}>
                  <span className='countdown-progress-bar'
                        style={{transform:`scaleY(${this.state.loaderPercentage/(this.props.timeOut*10)})`,backgroundColor:this.state.color}} >
                  {/*<span style={{transform:`scaleY(${this.state.loaderPercentage}%)`,backgroundColor:this.state.color}} >*/}
                  </span>
                    <img style={{alignSelf:'center'}} className="countdown-progress-light-icon" src={LightImage} alt=""/>
                </Grid>
                <p className="countdown-progress-text">
                    {( Math.abs(this.state.loaderPercentage-(this.props.timeOut*10))/10)
                    }
                </p>
            </Grid>
        )
    }
}
export default CountdownProgress